import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { LoadingShell } from './ui-bits';

export function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingShell />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (role === 'super' && user.role !== 'superadmin') return <Navigate to="/app/dashboard" replace />;
  if (role === 'tenant' && user.role === 'superadmin') return <Navigate to="/superadmin/dashboard" replace />;
  return children;
}
